<div class="c-modal c-modal--md">
	<div mat-dialog-content class="c-modal__dialog">
		<div class="c-modal__header">
			<div class="o-grid">
				<div class="o-grid__cell u-no-p"></div>
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
					<button id="closeButton" class="c-button c-button--icon c-button--tp c-modal__close" (click)="vm.close()">
						<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
						<span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
					</button>
				</div>
			</div>
		</div>
		<div class="c-modal__content u-no-pt">
			<div class="c-card c-card--height-fit" style="box-shadow:none;">
				<form name="vm.form" class="c-form u-ost-xl">
					<div class="o-grid__cell o-grid__cell--w-100 u-no-p">
						<div class="c-form__group u-no-m">
							<label for="medication" class="c-form__label">{{ 'Drug_Search.Open' | translate }}</label>
							<input-autocomplete id="medication" [displayPlaceHolder]="true" name="medication" [(model)]="vm.formData.medication" [selectFn]="vm.handleSelect" [searchFn]="vm.handleMedicationSearch" [minLength]="3"></input-autocomplete>
						</div>
						<ul style="position:unset;background-color:rgb(246, 244, 244);" class="c-autocomplete__list">
							<li style="cursor:default;" class="c-autocomplete__item" *ngFor="let item of vm.items ; let $index=index" tabindex="-1">
								<div style="display:flex;flex-direction: row;align-items: stretch;" *ngIf="item">
									<ng-container *ngIf="item.picture">
										<img style="margin:5px;height:40px;width:40px;vertical-align:middle;object-fit:contain;object-position:center;" [src]="item.picture">
									</ng-container>
									<div style="margin:5px;flex-grow:1;align-items:center;">
										<div id="itemNameLabel">{{item.fullName}}</div>
										<div>{{ 'Drug_Search.Available' | translate }}{{item.quantity ? item.quantity : 0}}{{item.price ? '/' + item.price : ''}}{{item.discountPrice ? '/' + item.discountPrice : ''}}</div>
									</div>
									<button id="removeItemButton" type="button" style="position: unset;top: 0;transform: none;margin: 15px 0px 0px 10px;min-width:20px;" class="c-form__input-btn" (click)="vm.removeItem($index)">
										<i class="o-icon o-icon--x" aria-hidden="true"></i>
										<span class="u-sr-only">{{ 'Common.Cancel' | translate }}</span>
									</button>
								</div>
							</li>
						</ul>
					</div>
				</form>
				<div class="o-grid">
					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-p u-ost-md">
						<button id="medicationSearchButton" type="button" class="c-button c-button--s2 c-button--fit" (click)="vm.submit()" [disabled]="vm.processing || !vm.initialized">{{ 'Drug_Search.Send' | translate }}</button>
					</div>
				</div>
				<loader-overlay *ngIf="vm.processing || !vm.initialized"></loader-overlay>
			</div>
		</div>
	</div>
</div>
